/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sd_Description_Length_HelpInputs */



/**
* | output |
* | --- |
* | "Shorter scene descriptions are easier to scan when reviewing your project." |
*
* @param {Sd_Description_Length_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const sd_description_length_help = /** @type {((inputs?: Sd_Description_Length_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sd_Description_Length_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Des descriptions de scènes plus courtes sont plus faciles à parcourir lors de la révision de votre projet.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Kürzere Szenenbeschreibungen lassen sich beim Durchsehen Ihres Projekts leichter überfliegen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Descrizioni delle scene più brevi sono più facili da consultare durante la revisione del progetto.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Кратковременные описания сцен легче просматривать при оценке проекта.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Las descripciones de escenas más breves son más fáciles de leer al revisar tu proyecto.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("较短的场景描述在审阅项目时更容易浏览。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("シーンの説明が短い方が、プロジェクトを確認する際にざっと目を通しやすい。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अपने प्रोजेक्ट की समीक्षा करते समय छोटे दृश्य विवरणों को पढ़ना आसान होता है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Descrições de cena mais curtas são mais fáceis de analisar durante a revisão do seu projeto.")
	return /** @type {LocalizedString} */ ("Shorter scene descriptions are easier to scan when reviewing your project.")
});